import { Injectable } from '@angular/core'
import { HttpService } from '@surgetech-eu/core'
import { Observable } from 'rxjs'
import { Suppliers } from './suppliers.service'
import { LibraryModel } from '../models'

export interface SupplierType extends LibraryModel {
    new?: boolean
}
export const disabledColumnOptions = new Map<string, string>([
    ['true', 'Disabled'],
    ['false', 'Enabled']
])
export const url = '/libraries/management/types/supplierType/entries'

@Injectable()
export class SupplierTypeService {
    constructor(private http: HttpService) {}
    getAll(): Observable<Suppliers[]> {
        return this.http.get(url)
    }

    remove(data: SupplierType[]): Observable<boolean> {
        return this.http.delete(url + '/', { data })
    }

    create(data: SupplierType[]): Observable<unknown> {
        return this.http.post(url, { data })
    }
    update(data: SupplierType[]): Observable<unknown> {
        return this.http.put(url, { data })
    }
}
